import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user

  useEffect(() => {
    const check = async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      }
    };
    check();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("token", data.token);
    try { const me = await api.get("/auth/me"); setUser(me.data); return me.data; }
    catch { setUser(data); return data; }
  };

  const applyAuth = async (data) => {
    if (data?.token) localStorage.setItem("token", data.token);
    try { const me = await api.get("/auth/me"); setUser(me.data); return me.data; }
    catch { setUser(data); return data; }
  };

  const register = async (name, email, password, referralCode, agreed, signature) => {
    const { data } = await api.post("/auth/register", {
      name, email, password, referral_code: referralCode || null,
      agreed: !!agreed, signature: signature || null,
    });
    if (data.token) localStorage.setItem("token", data.token);
    try { const me = await api.get("/auth/me"); setUser(me.data); return me.data; }
    catch { setUser(data); return data; }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(false);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshUser, applyAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
